const preparePath = (path) => {
    if (path.charAt(path.length - 1) != '/') {
        path += '/';
    }
    return path;
};

export default (path1, path2) => {
    return preparePath(path1) == preparePath(path2);
};
